import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  Region,
  RegionFilters,
  RegionRequest,
  RegionsResponse,
  UpdateRegionPayload,
} from "../../schemas/regionSchema";

const GET_REGIONS = gql`
  query GetRegions($page: Int, $pageSize: Int, $search: String, $cityId: ID) {
    regions(
      page: $page
      pageSize: $pageSize
      search: $search
      cityId: $cityId
    ) {
      regions {
        id
        name
        cityId
        city {
          id
          name
        }
        tenantId
        createdBy
        createdAt
        updatedAt
        screens {
          id
          screenName
        }
      }
      page
      pageSize
      total
      totalPages
      hasNextPage
      hasPrevPage
    }
  }
`;

const GET_REGION_BY_ID = gql`
  query GetRegionById($id: ID!) {
    region(id: $id) {
      id
      name
      cityId
      city {
        id
        name
      }
      tenantId
      createdBy
      createdAt
      updatedAt
      screens {
        id
        screenName
      }
    }
  }
`;

const CREATE_REGION = gql`
  mutation CreateRegion($input: CreateRegionInput!) {
    createRegion(input: $input)
  }
`;

const UPDATE_REGION = gql`
  mutation UpdateRegion($id: ID!, $input: UpdateRegionInput!) {
    updateRegion(id: $id, input: $input)
  }
`;

const DELETE_REGIONS = gql`
  mutation DeleteRegions($ids: [ID!]!) {
    deleteRegions(ids: $ids)
  }
`;

export const regionService = {
  getAll: async (filters: RegionFilters = {}): Promise<RegionsResponse> => {
    const { data } = await client.query({
      query: GET_REGIONS,
      variables: filters,
      fetchPolicy: "network-only",
    });
    return data.regions;
  },

  getById: async (id: string): Promise<Region> => {
    const { data } = await client.query({
      query: GET_REGION_BY_ID,
      variables: { id },
      fetchPolicy: "network-only",
    });
    return data.region;
  },

  create: async (input: RegionRequest): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: CREATE_REGION,
      variables: { input },
    });
    return data.createRegion;
  },

  update: async (payload: UpdateRegionPayload): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: UPDATE_REGION,
      variables: {
        id: payload.id,
        input: payload.region,
      },
    });
    return data.updateRegion;
  },

  remove: async (ids: string[]): Promise<boolean> => {
    const { data } = await client.mutate({
      mutation: DELETE_REGIONS,
      variables: { ids },
    });
    return data.deleteRegions;
  },
};
